import React from 'react';
import classes from '../fifty_check.module.css';

export const LPFooter = () => {
  return <div className={classes.footer}>提供: 株式会社Bluezone</div>;
};
